function closeMiniCart() {
  var miniCart = document.getElementById("mini-cart");
  if (miniCart.hasAttribute("open")) {
    miniCart.removeAttribute("open");
  }
}

$(document).on("click", ".tab-set-unique1 .tab-link", function () {
  var tabId = $(this).data("tab");
  var tabSet = $(this).closest(".tab-set");

  tabSet.find(".tab-link").removeClass("active");
  tabSet.find(".tab-content").hide();
  $(".hidde-burger-slider").hide();
  $(".slider-" + tabId).show();
  $(this).addClass("active");

  $("#" + tabId).fadeIn();
});

// Function to update the variant ID and image
function updateVariantIdAndImage(productForm) {
  const productData = JSON.parse(productForm.dataset.productJson);
  const selectedOptions = [];

  // Collect selected options
  productData.options.forEach((option, index) => {
    const select = productForm.querySelector(`select[name="option-${index}"]`);
    selectedOptions.push(select.value);
  });

  // Find the matching variant
  const matchingVariant = productData.variants.find((variant) => {
    return variant.options.every(
      (option, index) => option === selectedOptions[index]
    );
  });

  // Get elements once
  const productItem = productForm.closest(".product-item");
  const imageElement = productItem.querySelector(".product-image img");
  const addToCartButton = productForm.querySelector(".add-to-cart-button");
  const soldOutBadge = productForm.querySelector(".sold-out-badge");

  if (matchingVariant) {
    productForm.querySelector(".variant-id").value = matchingVariant.id;

    // Update image if available
    if (
      matchingVariant.featured_media &&
      matchingVariant.featured_media.preview_image &&
      matchingVariant.featured_media.preview_image.src
    ) {
      if (
        imageElement.src !== matchingVariant.featured_media.preview_image.src
      ) {
        imageElement.src = matchingVariant.featured_media.preview_image.src;
      }
    }

    // Update button state
    if (matchingVariant.available) {
      addToCartButton.classList.remove("not-available-variant");
      addToCartButton.classList.add("available-variant");
      addToCartButton.disabled = false;
      soldOutBadge.style.display = "none";
    } else {
      addToCartButton.classList.remove("available-variant");
      addToCartButton.classList.add("not-available-variant");
      addToCartButton.disabled = true;
      soldOutBadge.style.display = "inline";
    }
  } else {
    productForm.querySelector(".variant-id").value = "";
    imageElement.src = productData.featured_image.src;

    addToCartButton.classList.remove("available-variant");
    addToCartButton.classList.add("not-available-variant");
    addToCartButton.disabled = true;
    soldOutBadge.style.display = "inline";
  }

  console.log("Variant update completed");
}

// Function to handle onchange event
function myFunction(selectElement) {
  // Find the closest product form from the select element
  const productForm = selectElement.closest(".product-form");

  // Call the update function
  updateVariantIdAndImage(productForm);
}

// document.addEventListener("DOMContentLoaded", (event) => {
//   setupRatingSnippet();
//   setTimeout(function () {
//     setupRatingSnippet();
//   }, 500); // Delay for 1 second
// });

// setupRatingSnippet();
// document.addEventListener("cart:refresh", function (event) {
//   setTimeout(function () {
//     setupRatingSnippet();
//   }, 300); // Delay for 1 second
// });

// Select elements
const versandOpenPopupBtn = document.getElementById("versand-open-popup");
const versandClosePopupBtn = document.getElementById("versand-close-popup");
const versandPopup = document.getElementById("versand-popup");
const versandPopupOverlay = document.getElementById("versand-popup-overlay");
const versandBody = document.body;

// Function to open the popup
function versandOpenPopup() {
  versandPopup.style.display = "block";
  versandPopupOverlay.style.display = "block";
  versandBody.classList.add("versand-no-scroll"); // Disable scrolling on body
}

// Function to close the popup
function versandClosePopup() {
  versandPopup.style.display = "none";
  versandPopupOverlay.style.display = "none";
  versandBody.classList.remove("versand-no-scroll"); // Enable scrolling on body
}

if (versandOpenPopupBtn) {
  versandOpenPopupBtn.addEventListener("click", versandOpenPopup);
}

if (versandClosePopupBtn) {
  versandClosePopupBtn.addEventListener("click", versandClosePopup);
}

if (versandPopupOverlay) {
  versandPopupOverlay.addEventListener("click", versandClosePopup);
}

function checkClassOnSelectedMedia() {
  if ($(".product__media-item.is-selected").hasClass("info-bar-active")) {
    $(".custom-lines-only").removeClass("lines-present");
    $(".custom-arrow-only").removeClass("lines-present-2");
  } else {
    $(".custom-lines-only").addClass("lines-present");
    $(".custom-arrow-only").addClass("lines-present-2");
  }
}

checkClassOnSelectedMedia();

// Overflow-Scroller for CP Swatches
document.addEventListener("DOMContentLoaded", function () {
  // Funktion, um zu überprüfen, ob ein Element überläuft
  function hasOverflow(element) {
    return element.scrollWidth > element.clientWidth;
  }

  const elements = document.querySelectorAll(
    ".product-item-meta__variation-products .inner"
  );

  elements.forEach((element) => {
    if (hasOverflow(element)) {
      element.classList.add("has-overflow");
    }
  });
});

// const sliders = document.querySelectorAll('.product-item-meta__variation-products .inner');

// sliders.forEach(slider => {
//     let isDown = false;
//     let startX;
//     let scrollLeft;

//     slider.addEventListener('mousedown', (e) => {
//         isDown = true;
//         slider.classList.add('active');
//         startX = e.pageX;
//         scrollLeft = slider.scrollLeft;
//     });

//     slider.addEventListener('mouseleave', () => {
//         isDown = false;
//         slider.classList.remove('active');
//     });

//     slider.addEventListener('mouseup', () => {
//         isDown = false;
//         slider.classList.remove('active');
//     });

//     slider.addEventListener('mousemove', (e) => {
//         if (!isDown) return;  // Stop the function from running if not clicked
//         e.preventDefault();
//         const x = e.pageX - startX;
//         slider.scrollLeft = scrollLeft - x * 2;  // Adjust scrolling speed by multiplying
//     });
// });

/* Image Switch on CP */
document
  .querySelectorAll(".product-item .color-relations .variant-swatch__item")
  .forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();

      const productItem = item.closest(".product-item");
      if (!productItem) return;

      productItem
        .querySelectorAll(".variant-swatch__item.active")
        .forEach((activeItem) => {
          activeItem.classList.remove("active");
        });

      item.classList.add("active");

      const primaryImage = productItem.querySelector(
        ".product-item__image-wrapper .product-item__primary-image"
      );
      if (item.getAttribute("data-primary-image") != "none") {
        const newPrimarySrc = item.getAttribute("data-primary-image");
        if (newPrimarySrc) {
          primaryImage.setAttribute("src", newPrimarySrc);
          primaryImage.setAttribute("srcset", newPrimarySrc);
        }
      }
      else {
        const newSecondarySrc = item.getAttribute("data-secondary-image");
        primaryImage.setAttribute("src", newSecondarySrc);
        primaryImage.setAttribute("srcset", newSecondarySrc);
      }

      const secondaryImage = productItem.querySelector(
        ".product-item__image-wrapper .product-item__secondary-image"
      );
      if (secondaryImage) {
        const newSecondarySrc = item.getAttribute("data-secondary-image");
        if (newSecondarySrc) {
          secondaryImage.setAttribute("src", newSecondarySrc);
          secondaryImage.setAttribute("srcset", newSecondarySrc);
        }
      }
      const variantUrl = item.getAttribute("data-variant-url");
      if (variantUrl) {
        const imageWrapperLink = productItem.querySelector(
          ".product-item__image-wrapper a"
        );
        if (imageWrapperLink) {
          imageWrapperLink.setAttribute("href", variantUrl);
        }

        const metaLink = productItem.querySelector(".product-item-meta a");
        if (metaLink) {
          metaLink.setAttribute("href", variantUrl);
        }
      }
    });
  });
/* -------------------------------
  Mobile Slick Carousel & Color Swatch
-------------------------------- */
(function () {
  const MOBILE_BREAKPOINT = 767;
  const $ = window.jQuery;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  // Parse swatch images
  function parseImagesFromSwatch(swatchEl) {
    let images = [];
    try {
      const arr = JSON.parse(swatchEl?.dataset.productImages || "[]");
      if (Array.isArray(arr) && arr.length) images = arr.filter(Boolean);
    } catch (e) {
      console.warn("Invalid JSON in data-product-images", e);
    }
    return images;
  }

  // Parse full product images (for products with no swatches)
  function parseImagesFromProduct(productItem) {
    let images = [];
    try {
      const arr = JSON.parse(productItem?.dataset.productImages || "[]");
      if (Array.isArray(arr) && arr.length) {
        images = arr.filter(Boolean);
      }
    } catch (e) {
      console.warn("Invalid JSON in data-product-images on product", e);
    }

    if (!images.length) {
      productItem.querySelectorAll(".product-item__image-wrapper img").forEach((img) => {
        if (img.src) images.push(img.src);
      });
    }
    return [...new Set(images)]; // no duplicates
  }

  // Build slider
  function buildCarousel(productItem, images, swatchEl) {
    const imageWrapper = productItem.querySelector(".product-item__image-wrapper");
    if (!imageWrapper) return;

    // Reuse anchor if present
    let anchor = imageWrapper.querySelector(".product-item__aspect-ratio");
    if (!anchor) {
      anchor = document.createElement("a");
      anchor.classList.add("product-item__aspect-ratio");
      imageWrapper.appendChild(anchor);
    }

    // Ensure href is correct
    anchor.href =
      swatchEl?.dataset?.variantUrl ||
      anchor.href ||
      productItem.querySelector("a")?.href ||
      "#";

    // Remove old carousel only
    const oldCarousel = anchor.querySelector(".product-card-carousel");
    if (oldCarousel) {
      if ($(oldCarousel).hasClass("slick-initialized")) {
        $(oldCarousel).slick("unslick");
      }
      oldCarousel.remove();
    }

    // Build new carousel
    const carousel = document.createElement("div");
    carousel.classList.add("product-card-carousel");

    images.forEach((src) => {
      const cell = document.createElement("div");
      const img = document.createElement("img");
      img.src = src;
      // img.loading = "lazy";
      // img.decoding = "async";
      img.loading = "eager";
      img.decoding = "sync";
      img.style.width = "100%";
      img.style.height = "100%";

      const wrapper = document.createElement("div");
      wrapper.classList.add("fade-wrapper");
      wrapper.appendChild(img);
      cell.appendChild(wrapper);
      carousel.appendChild(cell);
    });

    anchor.appendChild(carousel);

    $(carousel).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      swipe: true,
      autoplay: false,
      adaptiveHeight: false,
    });

    // Ensure images render before slider adjusts
    // $(carousel).find("img").each(function () {
    //   if (this.complete) {
    //     this.classList.add("loaded");
    //     $(carousel).slick("setPosition");
    //   } else {
    //     this.addEventListener("load", () => {
    //       this.classList.add("loaded");
    //       $(carousel).slick("setPosition");
    //     });
    //   }
    // });

    // Slide hint only if there’s more than 1 image and it's the first product card
    if (
      images.length > 1 &&
      productItem.matches(".collection-only.product-item:first-of-type") &&
      !productItem.dataset.slideHintRemoved
    ) {
      carousel.classList.add("slide-hint-animation");
    }


    // Stop slide hint on interaction
    document.querySelectorAll(".product-card-carousel").forEach((slider) => {
      ["mousedown", "touchstart", "click"].forEach((evt) =>
        slider.addEventListener(evt, stopSlideHint, { once: true })
      );
    });

    function stopSlideHint() {
      document.querySelectorAll(".slide-hint-animation").forEach((el) =>
        el.classList.remove("slide-hint-animation")
      );
      const firstProduct = document.querySelector(".collection-only.product-item:first-of-type");
      if (firstProduct) firstProduct.dataset.slideHintRemoved = "true";
    }
  }

  // Init a single product card
  function initProductItem(productItem) {
    if (!isMobile()) return;
    if (productItem.querySelector(".product-card-carousel.slick-initialized")) return;

    // Always define activeSwatch
    let activeSwatch =
      productItem.querySelector(".collection-only .variant-swatch__item.active") ||
      productItem.querySelector(".collection-only .variant-swatch__item");

    // ✅ Detect if product is on sale (exact match only)
    const tags = (productItem.dataset.productTags || "")
      .toLowerCase()
      .split(",")
      .map((t) => t.trim());
    const isSale = tags.includes("sale");

    // 🖼️ Pick images
    let images = [];
    if (isSale) {
      // Try to find a swatch for the sale variant
      const saleSwatch = Array.from(
        productItem.querySelectorAll(".variant-swatch__item")
      ).find((el) =>
        el.dataset.variantUrl?.toLowerCase().includes("sale")
      );

      if (saleSwatch) {
        images = parseImagesFromSwatch(saleSwatch);
        activeSwatch = saleSwatch; // mark this swatch active
      } else {
        images = parseImagesFromProduct(productItem);
      }
    } else {
      if (activeSwatch) {
        images = parseImagesFromSwatch(activeSwatch);
      } else {
        images = parseImagesFromProduct(productItem);
      }
    }

    // ✅ Build carousel only if we have images
    if (images.length) {
      // Limit to 6 images max
      images = images.slice(0, 6);
      buildCarousel(productItem, images, activeSwatch);
    }
  }


  // Init all product cards
  function initAllProductItems() {
    if (!isMobile()) return;
    document.querySelectorAll(".collection-only.product-item").forEach(initProductItem);
  }

  // Swatch click handler
  document.addEventListener("click", (e) => {
    if (!isMobile()) return;
    const swatch = e.target.closest(".collection-only .variant-swatch__item");
    if (!swatch) return;

    e.preventDefault();
    const productItem = swatch.closest(".collection-only.product-item");
    if (!productItem) return;

    productItem.querySelectorAll(".collection-only .variant-swatch__item.active").forEach((a) =>
      a.classList.remove("active")
    );
    swatch.classList.add("active");

    const images = parseImagesFromSwatch(swatch).slice(0, 6);
    if (images.length) buildCarousel(productItem, images, swatch);
  });

  // Observe product list changes
  const productList = document.querySelector(".product-facet");
  if (productList) {
    const observer = new MutationObserver(() => initAllProductItems());
    observer.observe(productList, { childList: true, subtree: true });
  }

  document.addEventListener("collection:updated", initAllProductItems);
  document.addEventListener("collection:sort", initAllProductItems);
  document.addEventListener("collection:pagination", initAllProductItems);
  window.addEventListener("resize", initAllProductItems);
  document.addEventListener("DOMContentLoaded", initAllProductItems);
})();


/* Fix - color swatch redirecting after selecting color from filter */

document.addEventListener('DOMContentLoaded', function() {
  // find the static parent element that contains the product grid.
  const productGrid = document.querySelector('#facet-main');

  // if the grid exists, add a single click listener to it.
  if (productGrid) {
    productGrid.addEventListener('click', function(event) {
      // Use .closest() to check if the clicked element (or one of its parents) is a variant swatch link.
      const swatchLink = event.target.closest('.variant-swatch__item');

      // If a swatch link was not clicked, do nothing.
      if (!swatchLink) {
        return;
      }

      // 1. Prevent the link from redirecting the page.
      event.preventDefault();

      // Find the main product item card that this swatch belongs to.
      const productItem = swatchLink.closest('.product-item');
      if (!productItem) {
        return;
      }
      
      // 2. Get the new image URLs from the clicked swatch's data attributes.
      const newPrimaryImageUrl = swatchLink.dataset.primaryImage;
      const newSecondaryImageUrl = swatchLink.dataset.secondaryImage;
      const newVariantUrl = swatchLink.dataset.variantUrl;

      // 3. Find the images and links to update within the product card.
      const primaryImage = productItem.querySelector('.product-item__primary-image');
      const secondaryImage = productItem.querySelector('.product-item__secondary-image');
      const productLink = productItem.querySelector('.product-item-meta__title');
      const imageLink = productItem.querySelector('.product-item__aspect-ratio');


      // 4. Update the images and links.
      if (primaryImage && newPrimaryImageUrl && newPrimaryImageUrl !== 'none') {
        primaryImage.src = newPrimaryImageUrl;
        primaryImage.srcset = newPrimaryImageUrl; // Or construct a proper srcset if needed
      }
      
      // The secondary image in your code is the first one, which is hidden/shown on hover.
      if (secondaryImage && newSecondaryImageUrl) {
        secondaryImage.src = newSecondaryImageUrl;
        secondaryImage.srcset = newSecondaryImageUrl;
      }
      
      // Update the main product and image links to point to the new variant.
      if (productLink && newVariantUrl) {
          productLink.href = newVariantUrl;
      }
      if (imageLink && newVariantUrl) {
          imageLink.href = newVariantUrl;
      }

      // 5. Update the "active" state on the swatches.
      const allSwatchesInCard = productItem.querySelectorAll('.variant-swatch__item');
      allSwatchesInCard.forEach(swatch => swatch.classList.remove('active'));
      swatchLink.classList.add('active');

    });
  }
});